const VisibilityTypes = {
  ADD_NEW_FILE_ACTION: 'ADD_NEW_FILE_ACTION',
  ADD_NEW_TRACKING_STATUS_ACTION: 'ADD_NEW_TRACKING_STATUS_ACTION',
  CLEAR_SELECTED_VISIBILITY: 'CLEAR_SELECTED_VISIBILITY',
  EDIT_DETAILS_BTN_ACTION: 'EDIT_DETAILS_BTN_ACTION',

  EDIT_GENETRAL_BTN_ACTION: 'EDIT_GENETRAL_BTN_ACTION',

  GET_SHIPMENT_NOTES_AND_DETAILS: 'GET_SHIPMENT_NOTES_AND_DETAILS',
  GET_SHIPMENT_NOTES_AND_DETAILS_FAIL: 'GET_SHIPMENT_NOTES_AND_DETAILS_FAIL',
  GET_SHIPMENT_NOTES_AND_DETAILS_SUCCESS: 'GET_SHIPMENT_NOTES_AND_DETAILS_SUCCESS',

  GET_SHIPPER_AND_CONSIGNEE_DETAILS: 'GET_SHIPPER_AND_CONSIGNEE_DETAILS',
  GET_SHIPPER_AND_CONSIGNEE_DETAILS_FAIL: 'GET_SHIPPER_AND_CONSIGNEE_DETAILS_FAIL',
  GET_SHIPPER_AND_CONSIGNEE_DETAILS_SUCCESS: 'GET_SHIPPER_AND_CONSIGNEE_DETAILS_SUCCESS',

  GET_TRACKING_STATUS_DETAILS: 'GET_TRACKING_STATUS_DETAILS',
  GET_TRACKING_STATUS_DETAILS_FAIL: 'GET_TRACKING_STATUS_DETAILS_FAIL',
  GET_TRACKING_STATUS_DETAILS_SUCCESS: 'GET_TRACKING_STATUS_DETAILS_SUCCESS',

  GET_VISIBILITY_EXCEL_DATA: 'GET_VISIBILITY_EXCEL_DATA',
  GET_VISIBILITY_EXCEL_DATA_FAIL: 'GET_VISIBILITY_EXCEL_DATA_FAIL',
  GET_VISIBILITY_EXCEL_DATA_SUCCESS: 'GET_VISIBILITY_EXCEL_DATA_SUCCESS',

  GET_VISIBILITY_PRODUCT_INFO: 'GET_VISIBILITY_PRODUCT_INFO',
  GET_VISIBILITY_PRODUCT_INFO_FAIL: 'GET_VISIBILITY_PRODUCT_INFO_FAIL',
  GET_VISIBILITY_PRODUCT_INFO_SUCCESS: 'GET_VISIBILITY_PRODUCT_INFO_SUCCESS',

  GET_VISIBILITY_SEARCH_LIST: 'GET_VISIBILITY_SEARCH_LIST',
  GET_VISIBILITY_SEARCH_LIST_CLEAR: 'GET_VISIBILITY_SEARCH_LIST_CLEAR',
  GET_VISIBILITY_SEARCH_LIST_FAIL: 'GET_VISIBILITY_SEARCH_LIST_FAIL',
  GET_VISIBILITY_SEARCH_LIST_SUCCESS: 'GET_VISIBILITY_SEARCH_LIST_SUCCESS',
  GET_VISIBILITY_SET_SEARCH_LIST_DATA: 'GET_VISIBILITY_SET_SEARCH_LIST_DATA',

  SENT_EMAIL_VISIBILITY: 'SENT_EMAIL_VISIBILITY',

  SET_SELECTED_VISIBILITY: 'SET_SELECTED_VISIBILITY',
  UPDATE_REF_AND_DOCK_NO: 'UPDATE_REF_AND_DOCK_NO',
  UPDATE_REF_AND_DOCK_NO_FAIL: 'UPDATE_REF_AND_DOCK_NO_FAIL',
  UPDATE_REF_AND_DOCK_NO_SUCCESS: 'UPDATE_REF_AND_DOCK_NO_SUCCESS',

  UPDATE_SHIPMENT_DETAILS: 'UPDATE_SHIPMENT_DETAILS',

  UPDATE_SHIPMENT_NOTE: 'UPDATE_SHIPMENT_NOTE',

  UPDATE_SHIPMENT_TRACKING_DETAILS: 'UPDATE_SHIPMENT_TRACKING_DETAILS',
  UPDATE_SHIPMENT_TRACKING_DETAILS_CLEAR: 'UPDATE_SHIPMENT_TRACKING_DETAILS_CLEAR',
  UPDATE_SHIPMENT_TRACKING_DETAILS_FAIL: 'UPDATE_SHIPMENT_TRACKING_DETAILS_FAIL',
  UPDATE_SHIPMENT_TRACKING_DETAILS_SUCCESS: 'UPDATE_SHIPMENT_TRACKING_DETAILS_SUCCESS',
  UPDATE_VISIBILITY_SEARCH_LIST: 'UPDATE_VISIBILITY_SEARCH_LIST',
  UPDATE_VISIBILITY_SEARCH_LIST_SUCCESS: 'UPDATE_VISIBILITY_SEARCH_LIST_SUCCESS',
};

// biome-ignore lint/style/noDefaultExport: TODO: fix
export default VisibilityTypes;
